/**
 * Получить кнопку Больше ответов для списка комментариев
 * @param { HTMLElement } list 
 * @returns { HTMLElement }
 */
const getMoreButton = (list) => {
    let id = list.dataset.commentId;
    let more = list.querySelector(`[data-more="${id}"]`);
  
    return more;
};

/**
 * Получить комментарии первого уровня в списке
 * @param { HTMLElement } list 
 */
const getChildren = (list) => {
    return Array.from(list.children).filter(el => el.classList.contains('comment'))
}

/**
 * Получение самого свежего потомка первого уровня (ребенка)
 * @param { HTMLElement[] } comments 
 * @returns { HTMLElement }
 */
const findLastComment = (comments) => {
    comments.sort((a, b) => {
        return b.created - a.created;
    });
    return comments[0];
};


/**
 * Получение потомков комментария
 * @param { HTMLElement } comment 
 * @param { number } depth Глубина вложенности
 */
const getDescendants = (comment, depth) => {
    let commentEntity = comment.querySelector('.comment-entity');
    
    let likeButton = commentEntity ? commentEntity.querySelector('[data-reaction="like"]') : null;
    let likesCount = likeButton ? likeButton.querySelector('[data-reaction-count]') : null;
    
    let data = {
        element: comment,
        likesCount: likesCount,
        created: comment.dataset.created,
        children: []
    };

    if (likesCount) {
        comment.style.order = -1 * (parseInt(likesCount.textContent) || 0) - 1;
    }

    if (!comment) return data;
    if (!depth) return data;

    depth = depth - 1;
    let childrenList = comment.querySelector(".comment__children");
    if (!childrenList) return data;

    data.childrenList = childrenList;
    data.more = getMoreButton(childrenList);

    let children = getChildren(childrenList);
    data.children = children.map(child => getDescendants(child, depth));

    data.childrenCount = data.children.reduce((total, child) => {
        return total + (child.childrenCount || 0) + 1;
    }, 0);

    return data;
}

export { getMoreButton, getChildren, findLastComment, getDescendants };